import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const FeesIcon: React.FC<SvgIconDefaultProps> = ({ className, testId }) => {
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99984 18.9583C9.3415 18.9583 8.7165 18.625 8.28317 18.0333L7.4415 16.9083C7.2665 16.675 7.03317 16.5416 6.78317 16.525C6.53317 16.5083 6.28317 16.625 6.08317 16.8333L5.60817 16.4166L6.0665 16.8416C4.85817 18.125 3.9415 18.025 3.49984 17.85C3.04984 17.675 2.2915 17.1 2.2915 15.25V5.86663C2.2915 2.16663 3.35817 1.04163 6.84984 1.04163H13.1415C16.6332 1.04163 17.6998 2.16663 17.6998 5.86663V15.25C17.6998 17.0916 16.9415 17.6666 16.4915 17.85C16.0498 18.025 15.1332 18.125 13.9248 16.8416C13.7248 16.625 13.4665 16.5166 13.2165 16.5333C12.9665 16.55 12.7248 16.6833 12.5498 16.9166L11.7082 18.0416C11.2832 18.625 10.6582 18.9583 9.99984 18.9583ZM6.73317 15.275C6.7665 15.275 6.80817 15.275 6.8415 15.275C7.45817 15.3083 8.0415 15.6333 8.43317 16.1583L9.28317 17.2833C9.6915 17.825 10.3165 17.825 10.7248 17.2833L11.5665 16.1583C11.9582 15.6333 12.5415 15.3083 13.1665 15.275C13.7915 15.2416 14.3998 15.5 14.8498 15.9833C15.4832 16.6583 15.8915 16.7416 16.0415 16.6833C16.2415 16.6 16.4582 16.1166 16.4582 15.25V5.86663C16.4582 2.85829 15.9332 2.29163 13.1498 2.29163H6.84984C4.0665 2.29163 3.5415 2.85829 3.5415 5.86663V15.25C3.5415 16.125 3.75817 16.6083 3.95817 16.6833C4.10817 16.7416 4.5165 16.6583 5.14984 15.9833C5.58317 15.525 6.14984 15.275 6.73317 15.275Z"
        fill="#5C5C5C"
      />
      <path
        d="M12.4998 11.6667C12.0332 11.6667 11.6665 11.2917 11.6665 10.8333C11.6665 10.375 12.0415 10 12.4998 10C12.9582 10 13.3332 10.375 13.3332 10.8333C13.3332 11.2917 12.9665 11.6667 12.4998 11.6667Z"
        fill="#5C5C5C"
      />
      <path
        d="M7.49984 7.50004C7.03317 7.50004 6.6665 7.12504 6.6665 6.66671C6.6665 6.20837 7.0415 5.83337 7.49984 5.83337C7.95817 5.83337 8.33317 6.20837 8.33317 6.66671C8.33317 7.12504 7.9665 7.50004 7.49984 7.50004Z"
        fill="#5C5C5C"
      />
      <path
        d="M7.19176 12.125C7.03343 12.125 6.8751 12.0667 6.7501 11.9417C6.50843 11.7 6.50843 11.3 6.7501 11.0584L12.3584 5.45005C12.6001 5.20838 13.0001 5.20838 13.2418 5.45005C13.4834 5.69172 13.4834 6.09172 13.2418 6.33338L7.63343 11.9417C7.51676 12.0667 7.35843 12.125 7.19176 12.125Z"
        fill="#5C5C5C"
      />
    </CustomSvg>
  );
};
export default FeesIcon;
